import css from './index.module.scss';
import EfImg from '@elem/ui/ef-img';
import { useLang } from '@/i18n';
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useEffect, useState } from 'react';
import EfVideo from '@elem/ui/ef-video';
import SmartInsights from '../SmartInsights';

type ItemType = {
    img: string;
    text: string;
};
export default function Modal2({ type, callback }: any) {
    const { t } = useLang('delta_pro_ultra.launch.detail.PowerBackup2');
    const [isPC, setIsPC] = useState(false);
    const [open, setIsOpen] = useState(false);
    const [video1, setVideo1] = useState<string[]>(['https://websiteoss.ecoflow.com/upload/video/1735870579297/C1_M.mp4']);
    const items: ItemType[] = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1735641085787/M01.png',
            text: t('modal_text1'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1735641085490/M02.png',
            text: t('modal_text2'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1735641085965/M03.png',
            text: t('modal_text3'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1735641086158/M04.png',
            text: t('modal_text4'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1735641085615/M05.png',
            text: t('modal_text5'),
        },
    ];

    const handleClose = () => {
        setIsOpen(false);
        setTimeout(() => {
            callback();
        }, 1000);
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsPC(window.innerWidth > 1024);
        }
    }, []);
    const handleVideoPlay = (cls: string) => {
        const IS_PC = window?.innerWidth > 1024;
        const video: HTMLVideoElement | null = document.querySelector(`.PowerBackup2 .${cls} .ef-video`);
        console.log('video', video);
        if (video) {
            video.currentTime = 0;
            video.play();
        }
    };
    useEffect(() => {
        setIsOpen(type);
        handleVideoPlay('box1');
    }, [type]);

    return (
        <div className={`modal PowerBackup2 ${css.modal} ${open ? 'open' : 'close'}`}>
            <div className="content">
                <svg className="close" onClick={handleClose} xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
                    <g clipPath="url(#clip0_1297_95200)">
                        <path
                            d="M28 49C39.598 49 49 39.598 49 28C49 16.402 39.598 7 28 7C16.402 7 7 16.402 7 28C7 39.598 16.402 49 28 49Z"
                            stroke="white"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M28 49C39.598 49 49 39.598 49 28C49 16.402 39.598 7 28 7C16.402 7 7 16.402 7 28C7 39.598 16.402 49 28 49Z"
                            stroke="#ccc"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path d="M35 21L21 35" stroke="#ccc" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M21 21L35 35" stroke="#ccc" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_1297_95200">
                            <rect width="56" height="56" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
                <div className={`box-1`}>
                    <div className="info">
                        <div className="inner">
                            <div className="label">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path
                                        d="M17 2H7C6.17157 2 5.5 2.67157 5.5 3.5V20.5C5.5 21.3284 6.17157 22 7 22H17C17.8284 22 18.5 21.3284 18.5 20.5V3.5C18.5 2.67157 17.8284 2 17 2Z"
                                        stroke="#4071FF"
                                        strokeWidth="2"
                                    />
                                    <path d="M11 5H13" stroke="#4071FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M10 19H14" stroke="#4071FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <span className="label-text">{t('PowerBackup_item1_label')}</span>
                            </div>
                            <p className="title">{t(`title1`)}</p>
                            <p className="desc">
                                {t.rich(`desc1`, {
                                    w: (tx: string) => <span className="w">{tx}</span>,
                                })}
                            </p>
                        </div>
                    </div>
                    <div className="video-box">
                        <EfVideo
                            pc={'https://websiteoss.ecoflow.com/upload/video/1735870579297/C1_M.mp4'}
                            poster="https://websiteoss.ecoflow.com/upload/image/1735870847185/C1_M.jpg"
                            // loop={false}
                            // autoPlay={true}
                            preload="none"
                        />
                    </div>
                </div>
                <div className="box2">
                    <div className="info">
                        <p className="title">{t('title2')}</p>
                        <p className="desc">{t('desc2')}</p>
                    </div>
                    {/* <Swiper
                        className="items"
                        modules={[Pagination, Navigation]}
                        navigation={!isPC}
                        pagination={!isPC}
                        loop={!isPC}
                        spaceBetween={isPC ? 24 : 0}
                        centeredSlides={!isPC}
                        slidesPerView={'auto'}
                        initialSlide={isPC ? 0 : items?.length - 1}
                    > */}
                    <div className="items">
                        {items?.map((item: ItemType, k: number) => (
                            <div className="item" key={item.text}>
                                <div className="item-img">
                                    <EfImg pc={item.img} />
                                </div>
                                <p className="item-text">{item.text}</p>
                            </div>
                        ))}
                    </div>
                    {/* </Swiper> */}
                </div>
                <SmartInsights />
            </div>
        </div>
    );
}
